import Button from "../../Reusable/Button";
import { useForm } from "react-hook-form";
import APIS from "../../../constant/EndPoint";
import useGetHook from "../../../customHooks/useGetHook";
import { useSearchParams } from "react-router-dom";
import ComboboxInput from "../../Reusable/ComboboxInput";
import Spinner from "../../Reusable/Spinner";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import TextField from "../../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useEffect, useState } from "react";

const animatedComponents = makeAnimated();
const ChangeStatus = ({ handleActionMenu, isLoading }: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    watch,
    clearErrors,
  } = useForm<any>();
  const [statusList, setStatusList] = useState([]);
  const [defaultValue, setDefaultValue] = useState();
  const { data } = useGetHook({
    queryKey: [watch("status")],
    url: watch("status") ? `${APIS.STATUS}${watch("status")}/` : APIS.STATUS,
    params: {},
  });
  const { data: gridData, isLoading: isDeliverystatusLoading } = useGetHook({
    queryKey: [`delivery-status`],
    url: `${APIS.DELIVERY_STATUS}`,
    params: {},
  });

  useEffect(() => {
    gridData?.map((item: any) => {
      if (item?.name === "Final") {
        setStatusList(item?.status_id);
      }
    });
  }, [gridData]);

  const handleEditStatusChange = (value: any) => {
    setDefaultValue(value);
  };

  return (
    <>
      <div className={tw`w-[600px]`}>
        {isDeliverystatusLoading ? (
          <Spinner />
        ) : (
          <form
            onSubmit={handleSubmit((data: any) =>
              handleActionMenu(data, defaultValue, "Change Status", setError)
            )}
            autoComplete="off"
          >
            <div className={tw`flex flex-col justify-between min-h-full`}>
              <div className={tw`mt-10`}>
                <Select
                  components={animatedComponents}
                  closeMenuOnSelect={true}
                  options={statusList}
                  onChange={handleEditStatusChange}
                />
              </div>

              {/* <ComboboxInput
          url={APIS.STATUS_NEXT}
          queryKey={"status"}
          register={register("status" as const, {
            required: "Status is required",
          })}
          errors={errors?.status}
          name={"status"}
          label={""}
          setValue={setValue}
          placeholder={"Search Status"}
          getValues={getValues}
          props={{ order_ids: searchParams.get("selectedItems") }}
          clearErrors={clearErrors}
        /> */}
              {!Array.isArray(data) && data?.name === "Partial Delivered" ? (
                <>
                  <TextField
                    label={"Collected COD"}
                    register={register("collected_cod" as const, {
                      required: "Collected COD is required",
                    })}
                    errors={errors?.collected_cod}
                  />
                  <TextField
                    label={"Remark"}
                    register={register("remark" as const, {
                      required: "Remark is required",
                    })}
                    errors={errors?.remark}
                  />
                </>
              ) : (
                ""
              )}
              <div className={tw`w-[100px] mr-4 absolute bottom-4 right-2`}>
                <Button label={"Submit"} isLoading={isLoading} />
              </div>
            </div>
          </form>
        )}
      </div>
    </>
  );
};

export default ChangeStatus;
